import { render, staticRenderFns } from "./DownloadAll.vue?vue&type=template&id=513dadff&scoped=true&"
import script from "./DownloadAll.vue?vue&type=script&lang=js&"
export * from "./DownloadAll.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAll.vue?vue&type=style&index=0&id=513dadff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513dadff",
  null
  
)

export default component.exports